import React from 'react';
import PropTypes from 'prop-types';
import { ListItem, ListItemText, ListItemAvatar, Typography } from '@material-ui/core';
import Avatar from 'sharedComponents/Avatar';
import AssociateLogo from 'sharedComponents/AssociateLogo';
import { getInitials, getFullUserName, capitalize } from 'utils';
import ContactsList from 'sharedComponents/ContactsList';
import MobileAppIcon from '../Icons/MobileAppIcon';

const EMAIL = 'email';
const PHONE = 'phone';
const CHAT = 'chat';

const ClientListItemMessage = ({ classes, client, customClientClickAction, contactType, isBrandNM }) => {
  const isAssociate = !!client?.isAssociate;
  const onItemClickHandler =
    ({ profileId, fullName, contact, clientData }) =>
    () =>
      contact &&
      customClientClickAction({
        profileId,
        fullName,
        contact,
        clientData,
        cmdId: profileId,
      });

  const onContactClickHandler = (profileId, fullName, clientData) => (contact) =>
    customClientClickAction({
      profileId,
      fullName,
      contact,
      clientData,
      cmdId: profileId,
    });

  const contactsPropName = contactType === PHONE ? 'phoneNumbers' : 'emails';
  let contacts = client[contactsPropName] || [];
  const ucaStanleyProfiles = (contactType === CHAT && client.ucaStanleyProfiles) || [];

  const isExistingStanleyProfile = !!client?.ucaStanleyProfiles?.length;

  if (contactType === PHONE) {
    contacts = contacts.map(({ type, number = '' }) => `${number}${type ? ` (${capitalize(type)})` : ''}`);
  }
  if (contactType === CHAT) {
    contacts = ucaStanleyProfiles.map((ucaStanleyProfileId) => ucaStanleyProfileId.split('|')[2]);
  }

  const [isContactListExpanded, onContactListExpanded] = React.useState(false);

  const fullName = getFullUserName(client);
  const initials = !client.image ? getInitials(fullName) : null;
  const { profileId, image } = client;
  const [defaultContact] = contactType === CHAT ? ucaStanleyProfiles : contacts;

  const secondary = (
    <ContactsList
      fixedHeight
      data-testid="contacts-list"
      items={contacts}
      onExpand={onContactListExpanded}
      onItemClick={onContactClickHandler(profileId, fullName, client)}
    />
  );

  const hideName = isContactListExpanded && contacts.length > 1;
  const primary = (
    <Typography className={classes.stanleyIconsWrapper}>
      {fullName} {isBrandNM && isExistingStanleyProfile && <MobileAppIcon />}
      {isAssociate && <AssociateLogo />}
    </Typography>
  );

  return (
    <ListItem
      disableGutters
      disabled={!defaultContact}
      data-testid="client-list-item"
      classes={{ root: classes.listItem }}
      key={profileId}
      onClick={onItemClickHandler({
        profileId: client.profileId,
        fullName,
        contact: defaultContact,
        clientData: client,
      })}
    >
      <ListItemAvatar classes={{ root: classes.avatarRoot }}>
        <Avatar src={image || null} classes={{ colorDefault: classes.avatarColor }}>
          {initials}
        </Avatar>
      </ListItemAvatar>
      <ListItemText
        classes={{ root: hideName ? classes.nameHidden : classes.name }}
        primary={primary}
        secondary={secondary}
        secondaryTypographyProps={{
          component: 'div',
        }}
      />
    </ListItem>
  );
};

ClientListItemMessage.propTypes = {
  classes: PropTypes.shape({}),
  client: PropTypes.shape({
    profileId: PropTypes.string,
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    email: PropTypes.string,
    phoneNumbers: PropTypes.arrayOf(PropTypes.object),
    image: PropTypes.string,
  }),
  contactType: PropTypes.oneOf([EMAIL, PHONE, CHAT]),
};

ClientListItemMessage.defaultProps = {
  classes: {},
  client: {},
  contactType: EMAIL,
};

export default ClientListItemMessage;
